import CalendarFilters from './CalendarFilters';
import ConsultationsFilters from './ConsultationsFilters';
import ElectionKeyUpdatesFilters from './ElectionKeyUpdatesFilters';
import InfluenceContactsFilters from './InfluenceContactsFilters';
import InfluenceFilters from './InfluenceFilters';
import LegislationFilters from './LegislationFilters';
import LibraryMaterialFilters from './LibraryMaterialFilters';
import LobbyingMaterialFilters from './LobbyingMaterialFilters';
import ParliamentaryRecordFilters from './ParliamentaryRecordFilters';
import CommitteePublicationsFilters from './CommitteePublicationsFilters';
import StakeholdersFilters from './StakeholdersFilters';
import TweetsFilters from './TweetsFilters';
import ParliamentLiveFilters from 'components/Dashboard/Filters/FiltersData/ParliamentLiveFilters';
import RegulationFilters from 'components/Dashboard/Filters/FiltersData/RegulationsFilters';
import PriorityUpdatesFilters from 'components/Dashboard/Filters/FiltersData/PriorityUpdatesFilters';
import NotesFilters from 'components/Dashboard/Filters/FiltersData/NotesFilters';
import CustomContactsFilters from 'components/Dashboard/Filters/FiltersData/CustomContacts';
import CrmInteractionsFilters from 'components/Dashboard/Filters/FiltersData/CrmInteractionsFilters';
import KeyUpdatesFilters from 'components/Dashboard/Filters/FiltersData/KeyUpdatesFilters';
import ConfigData from 'config/ConfigData';
import { UKDatesFilters, USADatesFilters } from 'components/Dashboard/Filters/FiltersData/DatesFilters';

const FiltersData = () => {
  return [
    ...KeyUpdatesFilters,
    {
      name: 'Update type',
      searchState: 'inbox',
      separateFilter: true,
      configHidden: ConfigData?.filters?.priority?.configHidden,
      pages: [
        'KeyUpdates',
        'Consultations',
        'Legislation',
        'ParliamentaryRecord',
        'Tweets',
        'LibraryMaterial',
        'LobbyingMaterial',
        'CommitteePublications',
      ],
      options: [
        {
          name: 'Priority updates only',
          filter: [
            {
              field: 'relevanceScore',
              value: String(import.meta.env.VITE_APP_PRIORITY_UPDATES_MIN_RELEVANCE_SCORE ?? 0.8),
              operator: 'num_gt',
            },
            {
              field: 'importanceScore',
              operator: 'num_gt',
              value: '0',
            },
          ],
        },
      ],
      infoTooltip: `PolicyMogul determines priority based on various factors including resource type, relevance to your organisation, and novelty of information. Click on an update's "Priority update" badge to see why it was deemed priority`,
      rateFeedOption: true,
    },
    {
      name: 'Sort by',
      searchState: 'freeSearch',
      type: 'sort',
      mainListSort: true,
      pages: ['KeyUpdates', 'Tweets', 'Legislation', 'ParliamentaryRecord', 'LibraryMaterial', 'CommitteePublications'],
      optionSelected: '',
      options: [
        {
          name: 'Most recent',
          filter: [
            {
              pages: ['KeyUpdates', 'Tweets', 'LibraryMaterial', 'CommitteePublications'],
              property: { field: 'dateTime', order: 'desc' },
            },
            {
              pages: ['Legislation', 'ParliamentaryRecord'],
              property: { field: 'lastImporterUpdatedAtUtc', order: 'desc' },
            },
          ],
        },

        {
          name: 'Most relevant',
        },
      ],
      updateFilter: true,
    },
    {
      name: 'Sort by',
      searchState: 'inbox',
      type: 'sort',
      pages: [
        'Legislation',
        'ParliamentaryRecord',
        'KeyUpdates',
        'Tweets',
        'LibraryMaterial',
        'LobbyingMaterial',
        'Campaigns',
        'CommitteePublications',
        'Regulations',
      ],
      optionSelected: 'Most recent',
      hidden: true,
      options: [
        {
          name: 'Most recent',
          filter: [
            {
              pages: [
                'Legislation',
                'ParliamentaryRecord',
                'KeyUpdates',
                'Tweets',
                'LibraryMaterial',
                'LobbyingMaterial',
                'Campaigns',
                'CommitteePublications',
                'Regulations',
              ],
              property: { field: 'feedItemId', order: 'desc' },
            },
          ],
        },
      ],
    },
    ...ConsultationsFilters,
    ...LegislationFilters,
    ...ParliamentaryRecordFilters,
    ...ParliamentLiveFilters,
    ...CommitteePublicationsFilters,
    ...CalendarFilters,
    ...StakeholdersFilters,
    ...TweetsFilters,
    ...InfluenceFilters,
    ...LibraryMaterialFilters,
    ...LobbyingMaterialFilters,
    ...InfluenceContactsFilters,
    ...ElectionKeyUpdatesFilters,
    ...RegulationFilters,
    ...(import.meta.env.VITE_APP_SHOW_PRIORITY_UPDATES === 'true' ? PriorityUpdatesFilters : []),
    ...CustomContactsFilters,
    ...NotesFilters,
    ...CrmInteractionsFilters,
    ...UKDatesFilters,
    ...USADatesFilters,
    {
      name: 'Search within results',
      searchState: 'activeSearch',
      pages: [
        'KeyUpdates',
        'Consultations',
        'Legislation',
        'ParliamentaryRecord',
        'Tweets',
        'LibraryMaterial',
        'LobbyingMaterial',
        'Campaigns',
        'CommitteePublications',
        'PriorityUpdates',
      ],
      type: 'search',
      value: '',
      updateFilter: true,
    },
  ];
};

export default FiltersData;
